/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Suspense, useCallback } from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';

import type { ComponentType, ReactNode } from 'react';

const useLazyComponent = <ComponentProps,>(
  Component: ComponentType<ComponentProps>,
  fallbackComponent: ReactNode,
  errorMessage: string,
) => {
  return useCallback(
    (props: ComponentProps) => {
      return (
        <ErrorBoundary debug={errorMessage}>
          <Suspense fallback={fallbackComponent}>
            {/* @ts-ignore */}
            <Component {...props} />
          </Suspense>
        </ErrorBoundary>
      );
    },
    [Component, fallbackComponent, errorMessage],
  );
};

export default useLazyComponent;
